"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALL_PROFILE_PERMISSIONS = exports.ProfilePermissions = void 0;
/**
 * Permission string catalog for the Enterprise "My Profile" self-service
 * module (ADR-033). Every key here is a SELF-scoped action — holding
 * `PROFILE_EDIT_SELF` never implies any ability to edit another user's
 * profile (that stays `PlatformPermissions.USER_UPDATE`, unchanged).
 * Format: `<module>:<action>` per /standards/NamingConvention.md, same
 * as every other catalog in this directory.
 */
exports.ProfilePermissions = {
    PROFILE_VIEW_SELF: 'profile:view-self',
    PROFILE_EDIT_SELF: 'profile:edit-self',
    PASSWORD_CHANGE_SELF: 'profile:password-change-self',
    MFA_MANAGE_SELF: 'profile:mfa-manage-self',
    SESSION_MANAGE_SELF: 'profile:session-manage-self',
    DEVICE_MANAGE_SELF: 'profile:device-manage-self',
    NOTIFICATION_MANAGE_SELF: 'profile:notification-manage-self',
    PREFERENCE_MANAGE_SELF: 'profile:preference-manage-self',
    DOCUMENT_UPLOAD_SELF: 'profile:document-upload-self',
    SIGNATURE_MANAGE_SELF: 'profile:signature-manage-self',
};
/** Every profile permission, flattened — used to seed the `permissions` table, and to grant to every role (not just system roles) since every employee manages their own account. */
exports.ALL_PROFILE_PERMISSIONS = Object.values(exports.ProfilePermissions);
//# sourceMappingURL=profile.permissions.js.map